import React, { FC, ReactElement, useRef } from 'react'
import styles from './Iframe.module.css'
import classNames from 'classnames'
import { useIsVisible } from '@/utils/hooks/useIsVisible'

const Iframe: FC<{ className?: string; src: string; srcDoc?: string; title?: string }> = (
	props,
): ReactElement => {
	const ref = useRef<HTMLDivElement>(null)
	const loaded = useIsVisible(ref, '200px', true)
	const title = props.title || 'Embedded content'

	const [iframeReady, setIframeReady] = React.useState(false)

	let src = props.srcDoc ? undefined : props.src

	if (!loaded) {
		src = undefined
	}

	return (
		<div ref={ref} className={classNames(props?.className, styles.wrapper)}>
			{loaded && !iframeReady && <div className={styles.skeleton} />}
			{(loaded || props.srcDoc) && (
				<iframe
					src={src}
					srcDoc={props.srcDoc}
					title={title}
					width="100%"
					height="100%"
					className={classNames(styles.iframe, { [styles.hidden]: !iframeReady && !props.srcDoc })}
					sandbox="allow-scripts"
					loading="lazy"
					scrolling="no"
					onLoad={() => setIframeReady(true)}
				/>
			)}
		</div>
	)
}

export default Iframe
